export default {
  chatWidget: {
    chatWithUs: 'Chatta con noi',
    welcomeTitle: 'Benvenuto su Bookivo!',
    welcomeMessage: 'Come possiamo aiutarti oggi?',
    continueChat: 'Continua la chat',
    startConversation: 'Inizia conversazione',
    formTitle: 'Raccontaci di più su di te',
    namePlaceholder: 'Il tuo nome',
    emailPlaceholder: 'La tua email',
    phonePlaceholder: 'Il tuo numero di telefono',
    nameRequired: 'Inserisci il tuo nome',
    emailRequired: 'Inserisci la tua email',
    emailInvalid: 'Inserisci un indirizzo email valido',
    phoneRequired: 'Inserisci il tuo numero di telefono',
    startChat: 'Inizia chat',
    chatTitle: 'Chat di supporto',
    chatTitleNoAgent: 'Connessione...',
    endChat: 'Termina chat',
    inputPlaceholder: 'Digita il tuo messaggio...',
    greeting: 'Ciao',
    greetingMessage: 'Come posso aiutarti oggi?',
    emoji: 'Emoji',
    uploadImage: 'Carica immagine',
    sending: 'Invio in corso...',
    uploadFailed: 'Caricamento fallito, riprova',
    fileTooLarge: 'La dimensione del file non può superare 10MB',
    invalidFileType: 'Possono essere caricati solo file immagine',
    sendFailed: 'Invio del messaggio fallito, riprova',
    imageSendFailed: 'Invio dell\'immagine fallito, riprova',
    connectionLost: 'Connessione persa, chiudi e riapri la chat',
    uploading: 'Caricamento immagine...',
    sessionEnded: 'Sessione terminata',
    rating: {
      title: 'Grazie per aver utilizzato il nostro servizio. Valuta la tua esperienza!',
      satisfied: 'Soddisfatto',
      dissatisfied: 'Insoddisfatto',
      placeholder: 'Benvenuto per suggerimenti',
      submit: 'Invia valutazione',
      endChat: 'Termina chat',
      backToChat: 'Torna alla chat',
      success: 'Grazie per il feedback!'
    }
  }
}
